module.exports = __webpack_public_path__ + "img/VIP-6.b73691d2.png";